import React from "react";
import { Container } from "react-bootstrap";
import ecom from "../../../../Asset/hero-ecommerce-1.svg";

const Fourth = () => {
  return (
    <>
      <section
        className="side-image-box-section pt-5"
        style={{ background: "var(--white-color)" }}
      >
        <Container>
          <div className="row align-items-center">
            <div className="col-xl-6 col-lg-12 order-2">
              <div className="info-content">
                <div className="title-paragraph">Fintech Web Development</div>
                <p>
                  A Fintech intuition needs a web presence that draws in clients
                  with its appearance and plan. We have Expert Web developers
                  and design processes that attention on client experience,
                  acquisition, performance and building trust. Likewise, we
                  really want to furnish our Fintech web development clients
                  with sites that perform well in web search tools and
                  proposition analytics that can assist organizations with
                  estimating their development.
                </p>
                <p>
                  For a Fintech firm, we can make client entryway to permit
                  client connecting with and automated framework that can deal
                  with huge volume of client which should be possible by
                  utilizing different network like execution, boundaries and
                  different settings for automation. We likewise made
                  representations experience during the cycle to comprehend the
                  development of venture better.
                </p>
              </div>
            </div>
            <div className="col-xl-6 col-lg-12 order-1">
              <div className="info-img">
                <img alt="infoImage" src={ecom} className="w-100" />
              </div>
            </div>
          </div>
        </Container>
      </section>
    </>
  );
};

export default Fourth;
